import React, { useState, useEffect } from 'react'
import { Table, IconButton, Icon, Panel, ButtonGroup, Row, Col, Dropdown } from 'rsuite'
// import pathname from '../../constants/pathname'
// import { useHistory } from 'react-router-dom'
import { budgetFormat } from '../../utils/formatterUtil'
// import EditButton from '../../components/buttons/editButton/EditButton'
import ConfirmWidget from '../confirm/ConfirmWidget'

export default function ManageBankAccountTable({
  schema,
  data,
  loading,
  onDelete,
  onSelect,
  isViewMode,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  // const history = useHistory()
  // const [tableData, setTableData] = useState([])
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [deleteObj, setDeleteObj] = useState({})

  // const fs = localStorage.getItem('fontSize')
  // const styleHeaderCell = { whiteSpace: 'normal', wordBreak: 'break-word' }

  // useEffect(() => {
  //   setTableData(schema.bankAccountValues)
  // }, [schema])

  return (
    <>
      <Table wordWrap height={400} loading={loading} data={data || []}>
        <Column width={70} align="center">
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              return index + 1
            }}
          </Cell>
        </Column>

        <Column width={250}>
          <HeaderCell>ธนาคาร</HeaderCell>
          <Cell dataKey="bankName" />
        </Column>

        <Column width={250} minWidth={250} flexGrow={1}>
          <HeaderCell>ชื่อบัญชี</HeaderCell>
          <Cell dataKey="accountName" />
        </Column>

        <Column width={180} minWidth={180}>
          <HeaderCell>สาขา</HeaderCell>
          <Cell dataKey="bankBranch" />
        </Column>

        <Column width={190}>
          <HeaderCell>เลขที่บัญชี</HeaderCell>
          <Cell dataKey="accountNo" />
        </Column>

        <Column width={140} align={'center'}>
          <HeaderCell>ประเภทบัญชี</HeaderCell>
          <Cell dataKey="accountType" />
        </Column>

        {/* <Column width={180}>
          <HeaderCell align={'center'}>เงินคงเหลือ</HeaderCell>
          <Cell style={{ textAlign: 'right' }}>
            {(rowData) => {
              return <span>{budgetFormat(rowData.balance)}</span>
            }}
          </Cell>
        </Column> */}

        <Column width={140} align={'center'}>
          <HeaderCell>ณ. วันที่</HeaderCell>
          <Cell dataKey="date" />
        </Column>

        {!isViewMode && (
          <Column width={190} align="center" fixed="right">
            <HeaderCell>จัดการ</HeaderCell>
            <Cell>
              {(rowData) => {
                return (
                  <>
                    <ButtonGroup>
                      <IconButton
                        appearance="ghost"
                        className="rs-btn-ghost-edit"
                        icon={<Icon icon="edit" className="bt-gost-icon-radius-edit" />}
                        onClick={() => onSelect(rowData)}
                        disabled={!rowData.isEditabled}
                      >
                        แก้ไข
                      </IconButton>
                      <IconButton
                        appearance="ghost"
                        className="rs-btn-ghost-cancel"
                        icon={<Icon icon="trash" className="bt-gost-icon-none-radius-cancel" />}
                        onClick={() => (setDeleteObj(rowData), setIsShowConfirm(true))}
                        disabled={!rowData.isEditabled}
                      >
                        ลบ
                      </IconButton>
                    </ButtonGroup>
                  </>
                )
              }}
            </Cell>
          </Column>
        )}
      </Table>

      <ConfirmWidget
        title={`ยืนยันการลบรายการ`}
        show={isShowConfirm}
        detail={`ยืนยันการลบ`}
        onCancle={() => {
          setIsShowConfirm(false)
          setDeleteObj({})
        }}
        onConfirm={() => {
          onDelete(deleteObj)
          setIsShowConfirm(false)
        }}
      />
    </>
  )
}
